import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { social } from 'settings';


const Icon = (props) => {
  const { href, icon, size } = props;
  return (
    <a
      style={{ fontSize: (!Number.isNaN(+size) ? `${size}rem` : size) }}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="icons"
    >
      <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
    </a>
  );
};

const SocialIcons = (props) => {
  const { size, customIcons } = props;

  const filteredSocial = {};

  Object.keys(customIcons).forEach((icon) => {
    if (social[icon].length > 0) {
      filteredSocial[icon] = { icon: customIcons[icon], href: social[icon] };
    }
  });

  Object.keys(social).forEach((name) => {
    if (social[name].length > 0 && filteredSocial[name] === undefined) {
      filteredSocial[`fab fa-${name}`] = social[name];
    }
  });

  const icons = Object.keys(filteredSocial).map(name => (
    <Icon
      key={name}
      href={filteredSocial[name].href || filteredSocial[name]}
      icon={filteredSocial[name].icon || name}
      size={size}
    />
  ));

  return (
    <div className="socialIcons">
      {icons}
    </div>
  );
};

export default SocialIcons;


SocialIcons.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  customIcons: PropTypes.shape(),
};

SocialIcons.defaultProps = {
  size: 'inherit',
  customIcons: {},
};

Icon.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

Icon.defaultProps = {
  size: 'inherit',
};
